
export function dispatchStageCompleteEvent(stageId, nextStageId) {
    const stageEvent = createStageCompleteEvent(stageId, nextStageId);

    document.dispatchEvent(stageEvent);
}

function createStageCompleteEvent(stageId, nextStageId) {
    return new CustomEvent("StageComplete", {
        detail: {
            stage: stageId,
            nextStage: nextStageId
        }
    });
}